class AgentChatService {
    constructor() {
        const rawBaseUrl = process.env.REACT_APP_CHATBOT_API_URL || process.env.CHATBOT_API_URL || '';
        this.apiBaseUrl = rawBaseUrl.replace(/\/+$/, '');
    }

    async getConversationMessages(conversationId) {
        if (!conversationId) {
            throw new Error('conversationId is required');
        }

        const url = `${this.apiBaseUrl}/conversations/${encodeURIComponent(conversationId)}/messages`;
        const response = await fetch(url, {
            method: 'GET',
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    }
}

const agentChatService = new AgentChatService();
export { AgentChatService };
export default agentChatService;
